var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnEyedropper = function SvgIcnEyedropper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.579 12.065-1.79 1.79-1.185-1.194-6.478 6.479-3.866 1.563L4 19.443l1.563-3.866 6.478-6.479-1.193-1.184 1.79-1.79 5.94 5.94Zm-2.177-7.328a2.52 2.52 0 0 1 3.563 0 2.52 2.52 0 0 1 0 3.563l-1.613 1.613-3.563-3.562 1.614-1.614Zm-9.41 11.79L6.1 18.601l2.075-.89 6.243-6.252-1.176-1.177-6.252 6.243Z",
    fill: "#292525"
  })));
};
export default SvgIcnEyedropper;